import React from "react"

export default function NewReviewVideoSimple(props) {
  let { settings} = props
  return (
    <div
      className="review-simple-container review-rcf-sub"
    >
      <div className="review-sub-simple-popup">
        <div className="popup-content my-submit-popup">
          <div style={{ display: "flex", flexDirection: "column", gap: "10px", alignItems: "center", }}>
            <h3 className="highlight review-text-heading">
                {"Review Submitted!"}
            </h3>
            <p className="review-simple-highlight review-text-submit">
                {"Thanks for your video review! A confirmation email is on its way, and your Cashback process will start shortly."}
            </p>
          </div>
          <div className="submit-btn-rcf-main-div-cont align-items-center">
            <a
              className="rcf-submit-btn-sub"
              style={{
                all:"unset",
                cursor: "pointer",
                color: "white"
              }}
              href={`https://${settings?.merchantId}`}
              target="_blank"
            >
              Close
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}
